import {
   Badge,
   BadgeProps,
   Image,
   useBreakpointValue,
   ColorProps,
   forwardRef,
} from '@chakra-ui/react';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { FaIcon } from '@ifixit/icons';
import { ReactNode } from 'react';
import { color } from '@core-ds/primitives';

export type ThemeColors = keyof typeof color;

export type FlagBadgeStyle = {
   themeColor: ThemeColors;
   iconColor?: ColorProps['color'];
} & BadgeProps;

export const FlagBadge = forwardRef(function FlagBadge(
   {
      icon,
      iconColor,
      imageSrc,
      themeColor,
      children,
      ...badgeProps
   }: {
      icon?: FontAwesomeIconProps['icon'];
      iconColor?: ColorProps['color'];
      imageSrc?: string;
      themeColor: ThemeColors;
      children?: ReactNode;
   } & BadgeProps,
   ref
) {
   const fontSize = useBreakpointValue({ base: '13px', sm: '14px' }, { ssr: false });
   const iconSize = useBreakpointValue({ base: '16px', sm: '20px' }, { ssr: false });

   return (
      <Badge
         padding="4px 6px"
         lineHeight="18px"
         borderRadius="4px"
         fontSize={fontSize}
         display="flex"
         sx={{ '& svg': { paddingRight: '4px' } }}
         textTransform="none"
         alignItems="center"
         background={`${themeColor}.100`}
         color={`${themeColor}.700`}
         border="1px solid"
         borderColor={`${themeColor}.300`}
         tabIndex={0}
         ref={ref}
         {...badgeProps}
      >
         {icon && (
            <FaIcon
               fontSize={iconSize}
               icon={icon}
               color={iconColor ? iconColor : `${themeColor}.500`}
            />
         )}
         {imageSrc && (
            <Image
               src={imageSrc}
               height={iconSize}
               width={iconSize}
               display="flex"
               alignSelf="center"
               paddingRight="4px"
            />
         )}
         {children}
      </Badge>
   );
});
